import layout from '@/layout'
export default {
    path: '/demo',
    component: layout,
    children: [
        {
            path: 'upimage',
            component: () => import('@/views/backstage/demo/uploader-image')
          }
    ]
}